import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

export default function Nave() {
  return (
    <Navbar expand="lg" variant="dark" bg="dark" fixed="top">
      <Container fluid>
        <Navbar.Brand as={Link} to="/">Voice GPT</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
            <Nav.Link as={Link} to="/home">Home</Nav.Link>
            <Nav.Link as={Link} to="/detection">Object Detection</Nav.Link>
            <Nav.Link as={Link} to="/webcame">Live Detection</Nav.Link>
            <Nav.Link as={Link} to="/image">Describe Image</Nav.Link>
          </Nav>
         

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
